import { styled } from 'styled-components';

import { ArrowRight } from '@src/components/atoms/icons/arrow-right';

import CardBadge from './card-badge';

export const CardWrapper = styled.div`
  position: relative;
  display: grid;
  cursor: pointer;
  overflow: hidden;
  background: var(--color-white);
  grid-template-areas:
    'image'
    'content';
  grid-template-columns: 1fr;
  grid-template-rows: 118px 1fr;
  grid-column-gap: 8px;
  border: 1px solid #eceae7;
  box-shadow: 0 10px 40px 0 #0000001a;
  z-index: var(--z-index-trip-card);
  border-radius: 16px;

  @media screen and (min-width: 420px) {
    grid-template-columns: 111px 1fr;
    grid-template-rows: 111px 1fr;
  }

  @media screen and (min-width: 768px) {
    grid-template-areas: 'image content actions';
    grid-template-columns: 210px 2fr auto;
    grid-template-rows: 120px;
    grid-column-gap: 20px;
    padding: 0 16px 0 0;
  }

  ${CardBadge} {
    position: absolute;
    top: 4px;
    left: 4px;
    z-index: 2;
    max-width: calc(100% - 16px);

    @media screen and (max-width: 767px) {
      padding-inline: 14px;
      padding-block-end: 2px;
      width: max-content;
      top: 8px;
      left: 8px;
      max-width: unset;
      font-size: 16px;
    }

    @media screen and (min-width: 768px) {
      top: 8px;
      left: 8px;
    }
  }
`;

export const CardImageWrapper = styled.div`
  grid-area: image;
  background-color: var(--color-white);
  position: relative;
  height: 100%;

  ${CardWrapper} > * > & {
    height: 100%;
  }

  img {
    display: block;
    height: 100%;
    width: 100%;
    max-width: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  @media screen and (min-width: 768px) {
    img {
      border-radius: 0;
    }
  }
`;

export const CardContent = styled.div`
  flex-direction: column;
  justify-content: center;
  display: flex;
  padding: 8px 16px;

  @media screen and (min-width: 768px) {
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
`;

export const CardActions = styled.div`
  grid-area: actions;

  a,
  button {
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ChevronWrapper = styled.div`
  display: none;

  @media screen and (min-width: 768px) {
    display: flex;
    align-items: center;
    color: var(--color-numa-black--400);
    justify-content: flex-end;
    cursor: pointer;
    margin-right: 0;
  }
`;

export const OngoingFutureTripCardWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

export const DesktopDates = styled.div`
  display: none;
  font: 400 16px var(--font-family-founders-grotesk);

  @media screen and (min-width: 420px) {
    display: block;
  }
`;

export const MobileDates = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  span {
    font: 500 20px var(--font-family-founders-grotesk);
  }

  @media screen and (min-width: 420px) {
    display: none;
  }
`;

export const SpacedContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media screen and (min-width: 420px) {
    display: block;
  }
`;

export const FormattedDateWrapper = styled.span`
  font: 500 20px var(--font-family-founders-grotesk);
`;

export const MobileOnGoingFutureTripCardWrapper = styled.a`
  display: grid;
  grid-template-rows: 118px 1fr;
  border: 1px solid #dedddb;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 24px;
  background-color: transparent;
  cursor: pointer;
`;

export const MobileOnGoingFutureTripCardImage = styled.div`
  position: relative;
  background-color: rgba(218, 218, 218, 0.29);
  overflow: hidden;
  pointer-events: none;
  border-radius: 24px 24px 0 0;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease !important;
    border-radius: 24px 24px 0 0;
  }

  & ${CardBadge} {
    position: absolute;
    z-index: 10;
    left: 8px;
    top: 8px;
  }

  :hover {
    img {
      transform: scale(1.05);
    }
  }
`;

export const MobileOnGoingFutureTripCardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px 16px;
  background-color: var(--color-white);
  border-radius: inherit;
`;

export const PropertyName = styled.h3`
  margin: 0;
  font: var(--font-h3);
  color: var(--color-numa-black--400);
`;

export const Dates = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: var(--color-numa-black--400);
  font: 500 20px / 24px var(--font-family-founders-grotesk);
`;

export const DatesArrow = styled(ArrowRight)`
  --arrow-size: 24px;

  flex: 0 0 auto;
  width: var(--arrow-size);
  height: var(--arrow-size);
  margin-block: calc((var(--line-height-dates) - var(--arrow-size)) / 2);
  color: var(--color-numa-black--250);
`;

export const GuestName = styled.p`
  font: 400 16px var(--font-family-founders-grotesk);
  color: var(--color-numa-black--300);
  margin: 0;
`;
